import React from "react";
import ProviderUserListItem from "../../components/providerUser/ProviderUserList/ProviderUserListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ProviderUserListPage = ()  => {

    useTitle(t`List Provider User`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ProviderUserListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ProviderUserListPage;
